export const PARTNER_TABLE = "partners"
export const PARTNER_TABLE_SCHEMA =
  "id, companyId, type, code, isActive, syncId"
